<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Users</div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="usersLoading"
                @click="$store.dispatch('users/loadAll')"
              >
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-download"
                @click="downloadCSV"
              >
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-filter-outline"
                :loading="usersLoading"
                @click="filterDialog = true"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="filter.search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="users">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 260px) !important"
                >
                  <datatable
                    :filter="gridFilter"
                    :externalFilter="externalFilter"
                    :flat="true"
                    :data="users"
                    :columns="columns"
                    selection="multiple"
                    ref="usersTable"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template slot="body-cell-role" slot-scope="data">
                      <q-td :props="data.props">
                        <q-chip
                          v-for="(up, index) in data.props.row.permissions"
                          :key="`userPermission_${index}`"
                          :style="`background: ${
                            roleColors[up.role]
                          }; font-size: 12px`"
                          class="text-white"
                        >
                          {{ up.role }}
                        </q-chip>
                      </q-td>
                    </template>
                    <template
                      slot="body-cell-association_name"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <q-chip
                          v-for="(
                            up, index
                          ) in data.props.row.permissions.filter(
                            (p) => p.association_name
                          )"
                          :key="`userPermission_${index}`"
                          style="font-size: 12px"
                          class="text-white"
                          color="primary"
                        >
                          {{ up.association_name }}
                        </q-chip>
                      </q-td>
                    </template>
                    <template slot="body-cell-auth0_id" slot-scope="data">
                      <q-td :props="data.props">
                        <q-icon
                          v-if="data.props.row.auth0_id"
                          name="mdi-check-circle-outline"
                          color="positive"
                          size="md"
                        ></q-icon>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          :loading="resendingInviteID == data.props.row.id"
                          @click="resendInviteEmail(data.props.row)"
                          round
                          flat
                        >
                          <q-icon name="mdi-email-sync-outline"></q-icon>
                          <q-tooltip>Resend Invite Email</q-tooltip>
                        </q-btn>
                        <q-btn
                          :loading="deletingID == data.props.row.id"
                          @click="deleteUser(data.props.row.id)"
                          round
                          flat
                          color="negative"
                        >
                          <q-icon name="mdi-trash-can-outline"></q-icon>
                          <q-tooltip>Remove User</q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" max-width="600px">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">New User</div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <userForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="(state) => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" max-width="600px" persistent>
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">User</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="close"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <userForm
            ref="editForm"
            :id="viewFormData.id"
            @close="close"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="filterDialog" persistent max-width="600px">
      <q-card v-if="filterDialog" tile style="width: 600px; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Filter</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="filterDialog = false">
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <div class="row q-pa-md">
            <div class="col-12 q-py-sm">
              <q-select
                label="Role"
                v-bind="siteCFG.fields.general"
                :options="userRoles"
                v-model="filter.role"
                clearable
              >
              </q-select>
            </div>
            <div class="col-12 q-py-sm">
              <autocomplete
                label="Association"
                :items="associations"
                :itemsLoading="associationsLoading"
                option_label="association_name"
                option_value="id"
                :id="filter.association_id"
                @changed="(val) => (filter.association_id = val)"
                clearable
              />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import userForm from "@/components/users/userForm.vue";
  import moment from "moment";
  import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";

  // import { Notify } from "quasar";

  export default {
    components: {
      datatable,
      userForm,
      autocomplete,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        users: "users/list",
        usersLoading: "users/listLoading",
        siteCFG: "settings/siteCFG",
        userRoles: "settings/userRoles",
        associations: "associations/list",
        associationsLoading: "associations/listLoading",
      }),
      gridFilter() {
        return this.filter;
      },
    },
    data: () => ({
      // data-table
      columns: [
        {
          name: "auth0_id",
          label: "Active",
          align: "left",
          field: "auth0_id",
          sortable: true,
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          sortable: true,
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "email",
          label: "Email",
          align: "left",
          field: "email",
          sortable: true,
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "role",
          label: "Role",
          align: "left",
          field: "role",
          sort: (a, b, rowA, rowB) => {
            let roleA = rowA.permissions[0] ? rowA.permissions[0].role : null;
            let roleB = rowB.permissions[0] ? rowB.permissions[0].role : null;
            if (!roleA) {
              return 1;
            }
            if (!roleB) {
              return -1;
            }
            return roleA.localeCompare(roleB);
          },
          sortable: true,
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "association_name",
          label: "Association",
          align: "left",
          field: "role",
          sortable: true,
          sort: (a, b, rowA, rowB) => {
            let assocA = rowA.permissions[0]
              ? rowA.permissions[0].association_name
              : null;
            let assocB = rowB.permissions[0]
              ? rowB.permissions[0].association_name
              : null;
            if (!assocA) {
              return 1;
            }
            if (!assocB) {
              return -1;
            }
            return assocA.localeCompare(assocB);
          },
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "created_at",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) =>
            val != null
              ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
              : "",
          sortable: true,
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "updated_at",
          label: "Updated At",
          align: "left",
          field: "updated_at",
          format: (val) =>
            val != null
              ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
              : "",
          sortable: true,
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "actions",
          label: "",
          align: "left",
          field: "actions",
          sortable: true,
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
      ],

      filter: {
        search: "",
        role: null,
        association_id: null,
      },
      filterDialog: false,

      createLoading: false,

      newDialog: false,

      // View and Edit
      viewFormData: {},
      saveLoading: false,
      viewDetailsDialog: false,

      deletingID: null,
      resendingInviteID: null,

      roleColors: {
        Admin: "#346cb0",
        "Sport Manager": "#ffdb00",
        "Waves Manager": "#e51821",
        Official: "#ff7f27",
        "Club Admin": "#363020",
        "Team Manager": "#4aa13f",
        "Sports Coordinator": "#715b6b",
        "Junior Coordinator": "#424e51",
        Coach: "#987fdf",
        Athlete: "#222222",
      },
    }),
    watch: {
      $route: function () {
        this.handleRoute();
      },
    },
    mounted() {
      this.loadData();
      this.handleRoute();

      this.$store.dispatch("associations/loadMembers");
    },
    methods: {
      handleDoubleClick(row) {
        this.$router.push(`${this.$route.path}/${row.id}`);
      },
      loadData() {
        this.$store.dispatch("users/loadAll");
        this.$store.dispatch("associations/loadAll");
      },
      handleRoute() {
        if (this.$route.params.user_id) {
          this.viewFormData = { id: this.$route.params.user_id };
          this.$nextTick(() => {
            this.viewDetailsDialog = true;
          });
        } else {
          this.viewDetailsDialog = false;
        }
      },
      close() {
        this.$router.push("/system/users");
      },
      deleteUser(id) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete a user, this is irreversible and all data for this user will be lost. Do you wish to continue?",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            let payload = {
              user_id: id,
            };

            this.deletingID = id;

            this.$store.dispatch("users/deleteUser", payload).then((result) => {
              this.deletingID = null;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
          }
        });
      },

      resendInviteEmail(user) {
        this.$swal({
          title: "Resend Invite Email",
          text: `This will set a new temporary password for ${user.name} and email their login details to ${user.email}. Do you wish to continue?`,
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            this.resendingInviteID = user.id;

            this.$store
              .dispatch("users/resendInviteEmail", { user_id: user.id })
              .then((result) => {
                this.resendingInviteID = null;
                if (result.Result == "Success") {
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message:
                      result.Response && result.Response.Message
                        ? result.Response.Message
                        : "There was an Error, Please try again later",
                  });
                }
              });
          }
        });
      },

      externalFilter(rows, terms, cols) {
        return rows.filter((row) => {
          let passed = 0;
          let passedAmount = 3;

          // Text Search
          if (this.filter.search != "" && this.filter.search != null) {
            for (let i = 0; i < cols.length; i++) {
              let val = `${row[cols[i].field]}`.toLowerCase();
              passed +=
                val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1
                  ? 1
                  : 0;

              if (passed == 1) {
                i = cols.length;
              }
            }
          } else {
            passed += 1;
          }

          // Role Filter
          if (
            !this.filter.role ||
            row.permissions.find((p) => p.role == this.filter.role)
          ) {
            passed += 1;
          }

          // Association Filter
          if (
            !this.filter.association_id ||
            row.permissions.find(
              (p) =>
                p.ref_id == this.filter.association_id && p.type == "Association"
            )
          ) {
            passed += 1;
          }

          if (passed == passedAmount) {
            return true;
          } else {
            return false;
          }
        });
      },

      downloadCSV() {
        let filename = "users.csv";

        let text = this.generateCSV(this.$refs.usersTable.selected);

        var element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/plain;charset=utf-8," + encodeURIComponent(text)
        );
        element.setAttribute("download", filename);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      },
      generateCSV(rows) {
        let newRows = rows.map((r) => {
          return {
            name: r.name,
            email: r.email,
            role: r.permissions[0] ? r.permissions[0].role : "",
            association: r.permissions[0]
              ? r.permissions[0].association_name
              : "",
          };
        });
        const csvString = [
          Object.keys(newRows[0]),
          ...newRows.map((item) => Object.values(item)),
        ]
          .map((e) => e.join(","))
          .join("\n");

        return csvString;
      },
    },
  };
</script>

<style scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }
</style>
